import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create(() => ({
  container: {
    paddingHorizontal: theme.spacing[5],
    paddingTop: theme.spacing[5],
  },
}));
